import { NextTermPlanningComponent } from './next-term-planning.component';

export const NextTermPlanningModule = angular
  .module('nextTermPlanning', [])
  .component('nextTermPlanning', NextTermPlanningComponent).name;
